// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c94b1d8a","732":"5ff999e1"}[chunkId] + ".chunk.js";
};